export default {
  methods: {
    listen(events, callback) {
      window.Events.listen(events, callback);
    },

    silence(events, callback) {
      window.Events.silence(events, callback);
    },

    dispatch(events, ...payload) {
      window.Events.dispatch(events, ...payload);
    },
  },
}
